import { t } from "i18next";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import DBModal from "../../component/global/DBModal";
import DBButton from "../../component/global/DBButton";
import DBSpinner from "../../component/global/DBSpinner";
import { ToastContext } from "../../component/global/ToastContext";
import { useRequest } from "../../hooks/helperData/useRequest";
import { SURVEY_LIST, surveyActionUrl } from "../../helperData/ApiAddress";
import { surveyStatusLabel, surveySubjectLabel, withPersonalScope } from "./constants";

export default function DuplicateSelectModal({
    show,
    onHide,
    onSuccess,
    personal = false,
}) {
    const toast = useContext(ToastContext);
    const [surveys, setSurveys] = useState([]);
    const [selected, setSelected] = useState(null);
    const [duplicateLoading, setDuplicateLoading] = useState(false);

    const [getSurveys, getSurveysLoading] = useRequest(SURVEY_LIST, "GET");

    useEffect(() => {
        if (!show) return;
        setSelected(null);
        getSurveys(withPersonalScope(personal, { page_size: 50 }))
            .then((r) => setSurveys(r.results || []))
            .catch(() => setSurveys([]));
    }, [show]);

    const handleDuplicate = () => {
        if (!selected) return;
        setDuplicateLoading(true);
        axios
            .post(
                surveyActionUrl(selected.id, "duplicate"),
                {},
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem(
                            "auth"
                        )}`,
                    },
                }
            )
            .then((r) => {
                toast(t("survey.duplicate.success"), "success");
                onSuccess?.(r.data, { isCreate: true });
            })
            .catch(() => toast(t("survey.duplicate.error"), "danger"))
            .finally(() => setDuplicateLoading(false));
    };

    return (
        <DBModal
            permanent
            show={show}
            minWidth={520}
            onHide={onHide}
            className="survey-template-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                closeLabel={t("survey.settings.help.close")}
                title={t("survey.create.duplicate")}
            />
            <DBModal.Content>
                {getSurveysLoading ? (
                    <DBSpinner tip={t("loading")} />
                ) : surveys.length === 0 ? (
                    <div className="surveys-empty">{t("survey.list.empty")}</div>
                ) : (
                    <div className="survey-template-list">
                        {surveys.map((survey) => (
                            <button
                                type="button"
                                key={survey.id}
                                className={
                                    selected?.id === survey.id
                                        ? "selected"
                                        : ""
                                }
                                onClick={() => setSelected(survey)}
                            >
                                <strong>{survey.title}</strong>
                                <span>
                                    {surveySubjectLabel(survey)}{" "}
                                    · {surveyStatusLabel(survey.status)}
                                </span>
                            </button>
                        ))}
                    </div>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("survey.action.duplicate")}
                    onClick={handleDuplicate}
                    loading={duplicateLoading}
                    disabled={!selected}
                />
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
